import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import type { RefObject } from 'react';

interface AssigneeSearchBoxProps {
    value: string;
    onChange: (value: string) => void;
    inputRef: RefObject<HTMLInputElement>;
}

/** Only rendered once the roster is long enough to need a filter - see the
 *  `showSearch` gate in AssigneeMenuList. */
export function AssigneeSearchBox({ value, onChange, inputRef }: AssigneeSearchBoxProps) {
    return (
        <div className="relative mb-1" onClick={(e) => e.stopPropagation()}>
            <MagnifyingGlassIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-gray-400" />
            <input
                ref={inputRef}
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Search people..."
                className="w-full pl-8 pr-2 py-1.5 text-xs border border-gray-200 rounded-lg focus:outline-none focus:border-gray-400"
            />
        </div>
    );
}
